import { render, staticRenderFns } from "./Aceite.vue?vue&type=template&id=61433274&scoped=true&"
import script from "./Aceite.vue?vue&type=script&lang=js&"
export * from "./Aceite.vue?vue&type=script&lang=js&"
import style0 from "./Aceite.vue?vue&type=style&index=0&id=61433274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61433274",
  null
  
)

export default component.exports